<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center">
          <v-btn icon="mdi-chevron-left" @click="$router.replace('/reports')" variant="elevated" :density="$vuetify.display.mdAndUp ? 'compact' : 'comfortable' " color="primary"></v-btn>
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Report dell utente <a v-if="item.user" @click="$router.push(`/users/${item.user._id}`)" class="text-primary text-decoration-underline cursor-pointer">{{item.user.name}} {{item.user.surname}}</a> del {{formatDate(item.date)}}</h2>
          <h3 class="mx-3" v-else>Report dell utente <a v-if="item.user" @click="$router.push(`/users/${item.user._id}`)" class="text-primary text-decoration-underline cursor-pointer">{{item.user.name}} {{item.user.surname}}</a> del {{formatDate(item.date)}}</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>
      <v-col cols="12">
        <ul>
          <li v-if="item.user" class="body-1"><span class="font-weight-bold">Email utente:</span> <a :href="'mailto:'+item.user.email">{{item.user.email}}</a></li>
          <li v-if="item.user" class="body-1"><span class="font-weight-bold">Telefono utente:</span> {{item.user.phone}}</li>
          <li v-if="item.kit" class="body-1"><span class="font-weight-bold">Pacchetto:</span> <a @click="$router.push(`/kits/${item.kit._id}`)" >{{item.kit.title.it}}</a></li>
          <li v-if="item.product" class="body-1"><span class="font-weight-bold">Prodotto:</span> <a @click="$router.push(`/products/${item.product._id}`)">{{item.product.title.it}}</a></li>
          <li v-if="item.lesson" class="body-1"><span class="font-weight-bold">Lezione:</span> <a @click="$router.push(`/lessons/${item.lesson._id}`)">{{item.lesson.title.it}}</a></li>
          <li class="body-1"><span class="font-weight-bold">N° allenamenti a settimana:</span> {{item.trainings_per_week}}</li>
          <li class="body-1"><span class="font-weight-bold">Peso (kg):</span> {{item.weight}}</li>
          <li class="body-1"><span class="font-weight-bold">Fatica percepita in questo allenamento (da 1 a 5):</span> {{item.borg}}</li>
          <li class="body-1">
            <span class="font-weight-bold">Rispetto agli allenamenti già svolti hai percepito molta fatica?</span>
            {{item.perceived_fatigue ? "Sì" : "No"}}, <span v-if="item.perceived_fatigue_notes">Note: {{item.perceived_fatigue_notes}}</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Hai percepito più fatica durante lo svolgimento delle prime lezioni rispetto alle ultime?</span>
            {{item.perceived_fatigue_progress ? "Sì" : "No"}}, <span v-if="item.perceived_fatigue_progress_notes">Note: {{item.perceived_fatigue_progress_notes}}</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Hai percepito più fatica durante lo svolgimento delle prime lezioni rispetto alle ultime?</span>
            {{item.perceived_fatigue_progress ? "Sì" : "No"}}, <span v-if="item.perceived_fatigue_progress_notes">Note: {{item.perceived_fatigue_progress_notes}}</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Hai percepito la stessa fatica durante tutte le lezioni?</span>
            {{item.perceived_fatigue_all ? "Sì" : "No"}}, <span v-if="item.perceived_fatigue_all_notes">Note: {{item.perceived_fatigue_all_notes}}</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Pensi di essere pronto a cambiare categoria e livello di allenamento?</span>
            {{item.training_change_question ? "Sì" : "No"}}, <span v-if="item.training_change_question_notes">Note: {{item.training_change_question_notes}}</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Ci sono esercizi che non hai capito?</span>
            {{item.trainings_not_understood ? "Sì" : "No"}},
            <span v-if="item.trainings_not_understood_list && item.trainings_not_understood_list.length">Quali?
                        <v-chip class="ma-1" v-for="ex in item.trainings_not_understood_list" :key="ex._id + '_not_understood'" @click="$router.push('/exercises/'+ex._id)">{{ex.title.it}}</v-chip>
                      </span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Ci sono esercizi che non riesci a svolgere?</span>
            {{item.trainings_failed ? "Sì" : "No"}},
            <span v-if="item.trainings_failed_list && item.trainings_failed_list.length">Quali?
                        <v-chip class="ma-1" v-for="ex in item.trainings_failed_list" :key="ex._id + '_failed'" @click="$router.push('/exercises/'+ex._id)">{{ex.title.it}}</v-chip>
                      </span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Riesci sempre a rimanere nei tempi dei singoli esercizi?</span>
            {{item.training_in_time ? "Sì" : "No"}}, <span v-if="item.training_in_time_notes">Note: {{item.training_in_time_notes}}</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Come ti senti da quando hai iniziato ad allenarti?&nbsp;</span>
            <span v-if="item.feelings === 1">Male</span>
            <span v-if="item.feelings === 2">Normale</span>
            <span v-if="item.feelings === 3">Bene</span>
          </li>
          <li class="body-1">
            <span class="font-weight-bold">Altre considerazioni</span> {{item.notes}}
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import {inject, onMounted, ref} from "vue";
import api from "@/api";
import {useRoute, useRouter} from "vue-router";
import {Messages, Msg} from "@/plugins/messages.ts";
import type { ReportDisplay } from "@/models.ts"
export default {
  name: "CardView",
  setup() {
    const messages = inject('messages') as Messages
    const router = useRouter()
    const route = useRoute()
    const loading = ref<boolean>(false);
    const item = ref<ReportDisplay>({
      kit_id: "", lesson_id: "", product_id: "", user_id: "",
      date : '',
      weight : 0,
      trainings_per_week : 1,
      borg : 1,
      perceived_fatigue: false,
      perceived_fatigue_notes: "",
      perceived_fatigue_progress: false,
      perceived_fatigue_progress_notes: "",
      perceived_fatigue_all: false,
      perceived_fatigue_all_notes: '',
      training_change_question: false,
      training_change_question_notes: "",
      trainings_not_understood: false,
      trainings_not_understood_list : [],
      trainings_failed : false,
      trainings_failed_list : [],
      training_in_time : false,
      training_in_time_notes : "",
      feelings : 3,
      notes : ""
    })

    const loadData = async () => {
      loading.value = true;
      await router.isReady()
      const res = await api.get<ReportDisplay>('reports', `${route.params.id}?display=true`,)
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
      }
      if(res.data) item.value = res.data
      loading.value = false;
    }

    onMounted(async () => {
      await loadData()
    })

    return {
      loading,
      item,
      formatDate : utils.formatDateTime,
    };
  },
};
</script>
